module.exports = __webpack_public_path__ + "static/media/author-roger.9c72ec39.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/author-roger.png
// module id = 1787
// module chunks = 1